<template>
  <div class="content content--center welcome">
    <h1>Добро пожаловать в ТУСУР!</h1>

    <div class="welcome__text">
      <p>ТУСУР – университет, где создают будущее!</p>
      <p>
        Основанный в годы космических достижений, ТУСУР всегда готовил специалистов, которые востребованы в IT,
        электронике и связи. Выпускники ТУСУРа работают в ведущих компаниях, а обучение строится на реальных практических задачах.
      </p>
      <p>
        Твой путь к профессиональным вершинам начинается здесь — добро пожаловать в ТУСУР!
      </p>
    </div>

    <div class="welcome__content">
      <img v-svg-inline src="@images/robot-welcome.svg" class="welcome__robot" alt="">

      <div class="welcome__overlay">
        <ul class="welcome__steps">
          <li class="welcome__steps-item">
            <span class="welcome__steps-arrow"></span>
            Зарегистрируйся
          </li>
          <li class="welcome__steps-item">
            <span class="welcome__steps-arrow"></span>
            Найди свое заявление
          </li>
          <li class="welcome__steps-item">
            <span class="welcome__steps-arrow"></span>
            Следи за конкурсом
          </li>
          <li class="welcome__steps-item">
            Приходи учиться
          </li>
        </ul>

        <div class="welcome__actions">
          <a class="btn btn--lg btn--primary" :href="links.sign_up_url">Зарегистрироваться</a>
          <p>или</p>
          <a class="btn btn--lg btn--outline-primary" :href="links.sign_in_url">Войти</a>
        </div>

        <div class="welcome__questions">
          <p>Остались вопросы? Мы на связи:</p>

          <div class="welcome__phone">
            <img v-svg-inline src="@images/phone.svg" class="btn__icon welcome__phone-icon" alt="">
            <p>8-800-775-9025</p>
          </div>

          <ul class="join welcome__social">
            <a class="welcome__social-item" href="https://wa.me/79138002100">
              <img v-svg-inline src="@images/whatsapp.svg" class="btn__icon" alt="">
            </a>
            <a class="welcome__social-item" href="https://vk.com/abiturient_tusur">
              <img v-svg-inline src="@images/vk.svg" class="btn__icon" alt="">
            </a>
            <a class="welcome__social-item" href="https://t.me/abiturient_tusur">
              <img v-svg-inline src="@images/telegram.svg" class="btn__icon" alt="">
            </a>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const links = window.gon?.links || {}
</script>
